export default "__VITE_ASSET__BsMGwJen__"